import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { GlobalResponse, User } from '@app/shared-module/models';
import { Constants } from '@app/shared-module/constants';
import { AdminService } from '@app/services/admin.service';
import { CommonService } from '@app/shared-module/common-service.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-view-doctor-lead',
  templateUrl: './view-doctor-lead.component.html',
  styleUrls: ['./view-doctor-lead.component.css']
})
export class ViewDoctorLeadDialogComponent implements OnInit {
  user: User;
  isEditEnabled = false;
  public headerTitle: string;
  leadData: any;
  plan: any;
  doctorLeadID: string;
  doctorPlans: any[] = [];
  status_change = 'AUTO';
  @BlockUI() blockUI: NgBlockUI;
  constructor(
    public dialogRef: MatDialogRef<ViewDoctorLeadDialogComponent>,
    private service: AdminService,
    private toastr: ToastrService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.user = this.commonService.internalLoginValue;
    if (this.user && this.user.role && this.user.role === Constants.ROLE_ADMIN) {
      this.isEditEnabled = true;
    } else {
      this.isEditEnabled = false;
    }
    this.service.fetchDoctorPlans().subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        if (res.result.length > 0) {
          this.doctorPlans = res.result;
          this.plan = res.result[0]._id;
        }
      }
    });
  }

  approveLead() {
    this.blockUI.start();
    const req_obj = {
      doctorPlan: this.plan,
      status_change: this.status_change,
      trail_period_end: this.leadData.trail_period_end,
      subscriptionAmount: this.leadData.subscription_amount
    };
    this.service.approveDoctorLead(this.doctorLeadID, req_obj).subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        this.dialogRef.close(res.result);
        this.toastr.success('Lead Approved Successfully.');
      }
    }, (error: any) => {
      this.blockUI.stop();
      this.toastr.error(error);
    });
  }

  rejectLead() {
    this.blockUI.start();
    this.service.rejectDoctorLead(this.doctorLeadID, this.leadData).subscribe((res: GlobalResponse) => {
      this.blockUI.stop();
      if (res && res.message && res.message === Constants.STATUS_SUCCESS) {
        // console.log(res.result);
        this.dialogRef.close(res.result);
      }
    });
  }

}
